import React from 'react';
import { ExitDialog } from '../';
import './styles.css';

class Exit extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      confirmExit: false,
    };
  }

  handleExitDialogClose = () => {
    this.setState({ confirmExit: false });
  }

  handleExitDialogOpen = (e) => {
    e.preventDefault();
    this.setState({ confirmExit: true });
  }

  handleConfirmExit = (e) => {
    const { location, to, isLink, onClick } = this.props;
    e.preventDefault();

    if (isLink) {
      this.context.router.transitionTo({
        pathname: to,
        state: { from: (location && location.state.prevFrom) ? location.state.prevFrom : '/' },
      });
    } else {
      onClick();
    }
  }

  render() {
    const { color, requireConfirm } = this.props;
    const { confirmExit } = this.state;

    return (
      <div>
        <ExitDialog
          confirmExit={confirmExit}
          handleExitDialogClose={this.handleExitDialogClose}
          handleConfirmExit={this.handleConfirmExit}
        />
        <button className="exit" onClick={requireConfirm ? this.handleExitDialogOpen : this.handleConfirmExit}>
          <span className="icon-close-shadow" style={{ color }} />
        </button>
      </div>
    );
  }
}

Exit.propTypes = {
  location: React.PropTypes.any,
  to: React.PropTypes.string,
  color: React.PropTypes.string,
  requireConfirm: React.PropTypes.bool,
  isLink: React.PropTypes.bool,
  onClick: React.PropTypes.func,
};

Exit.defaultProps = {
  isLink: true,
};

export default Exit;



// WEBPACK FOOTER //
// ./src/browser/app/components/Exit/Exit.js